import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/no-data.png'


const _hoisted_1 = { class: "sbom-container" }
const _hoisted_2 = { class: "sbom-main" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "table-top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table-title" }, " · 反向追溯链 ")
], -1)
const _hoisted_4 = { class: "table-form" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "spe" }, "--", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, " Runtime Dependency举例场景： ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "B-Package运行时依赖于A-Package；", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "则A-Package作为反向追溯链查询的输入条件，", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "查询结果为B-Package的软件信息", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_14 = { class: "sbom-table" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "no-data" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "暂无相关内容")
], -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_17 = { class: "sbom-pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_form, {
          ref: "conditionFormRef",
          class: "query-list",
          model: _ctx.conditionForm,
          rules: _ctx.validateRules,
          "label-width": "auto",
          "status-icon": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "依赖类型",
              prop: "binaryType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.conditionForm.binaryType,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.conditionForm.binaryType) = $event)),
                  onChange: _ctx.handleBinaryType
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Package",
                      value: "PACKAGE_MANAGER"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Module",
                      value: "PROVIDE_MANAGER"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Dependency",
                      value: "EXTERNAL_MANAGER"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Runtime Dependency",
                      value: "RELATIONSHIP_MANAGER"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "包管理器类型",
              prop: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.conditionForm.type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.conditionForm.type) = $event)),
                  placeholder: "请选择包管理器类型"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "RPM",
                      value: "rpm"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Maven",
                      value: "maven"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Pypi",
                      value: "pypi"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Gitee",
                      value: "gitee"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Github",
                      value: "github"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Gitlab",
                      value: "gitlab"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Generic",
                      value: "generic"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "namespace" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.conditionForm.namespace,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.conditionForm.namespace) = $event)),
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "name",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.conditionForm.name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.conditionForm.name) = $event)),
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Version区间查询",
              prop: "isSection"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: _ctx.isSection,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isSection) = $event)),
                  clearable: "",
                  disabled: _ctx.sectionDisabled,
                  style: {"--el-switch-on-color":"#4971ff"}
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "",
              "label-width": "0"
            }, {
              default: _withCtx(() => [
                (_ctx.isSection)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_input, {
                        class: "input",
                        modelValue: _ctx.conditionForm.startVersion,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.conditionForm.startVersion) = $event)),
                        clearable: ""
                      }, null, 8, ["modelValue"]),
                      _hoisted_5,
                      _createVNode(_component_el_input, {
                        class: "input",
                        modelValue: _ctx.conditionForm.endVersion,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.conditionForm.endVersion) = $event)),
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ], 64))
                  : (_openBlock(), _createBlock(_component_el_input, {
                      key: 1,
                      class: "input",
                      modelValue: _ctx.conditionForm.version,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.conditionForm.version) = $event)),
                      clearable: ""
                    }, null, 8, ["modelValue"])),
                (_ctx.sectionDisabled)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 2,
                      placement: "top",
                      effect: "dark"
                    }, {
                      content: _withCtx(() => [
                        _hoisted_6,
                        _hoisted_7,
                        _hoisted_8,
                        _hoisted_9,
                        _hoisted_10,
                        _hoisted_11,
                        _hoisted_12
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { size: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_QuestionFilled)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.search(_ctx.conditionFormRef)))
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_el_table, {
          ref: "singleTableRef",
          data: _ctx.pageData,
          stripe: "",
          border: "",
          "highlight-current-row": ""
        }, {
          empty: _withCtx(() => [
            _hoisted_15
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              fixed: "",
              type: "index",
              label: "编号",
              width: "70",
              index: _ctx.indexCounter
            }, null, 8, ["index"]),
            _createVNode(_component_el_table_column, {
              property: "purl",
              "show-overflow-tooltip": "",
              label: "依赖描述符（PURL）",
              "min-width": "500"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, _toDisplayString(scope.row.purl), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              property: "name",
              "show-overflow-tooltip": "",
              label: "关联软件包名称",
              width: "200"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, _toDisplayString(scope.row.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              property: "version",
              label: "版本",
              width: "200"
            }),
            _createVNode(_component_el_table_column, {
              property: "description",
              "show-overflow-tooltip": "",
              label: "软件包描述",
              "min-width": "500"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, _toDisplayString(scope.row.description), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              "show-overflow-tooltip": "",
              label: "更多",
              width: "100"
            }, {
              default: _withCtx((props) => [
                _createVNode(_component_router_link, {
                  to: '/sbomPackageDetail/' + props.row.id + '/' + _ctx.isOpenEuler + '?productName=' + _ctx.getProductName,
                  target: "_blank",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_el_pagination, {
            layout: "total, sizes, prev, pager, next, jumper",
            "page-sizes": [10, 15, 20, 25, 30],
            total: _ctx.totalElements,
            "page-size": _ctx.pageSize,
            "onUpdate:page-size": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pageSize) = $event)),
            currentPage: _ctx.pageNum,
            "onUpdate:currentPage": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.pageNum) = $event)),
            onCurrentChange: _ctx.handlePageChange,
            onSizeChange: _ctx.handleSizeChange
          }, null, 8, ["total", "page-size", "currentPage", "onCurrentChange", "onSizeChange"])
        ])
      ])
    ])
  ]))
}